<template>
    <div>
      <button class="button is-fullwidth" @click="editPack()">ДОБАВИТЬ ПАКЕТ ПО</button>
      <div class="column is-8 is-offset-2">
        <div v-if="showForm">
          <b-field label="Название">
            <b-input v-model='pack.title' required></b-input>
          </b-field>
          <b-field label="GrottBjörn ID">
            <b-input v-model='pack.sourceId' type="number" required></b-input>
          </b-field>
          <b-field label="Состав пакета">
            <Multiselect
              v-model="pack.apps"
              :options="apps"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :hide-selected="true"
              placeholder="Выберите ПО"
              select-label="Нажмите Enter чтобы выбрать"
              label="title"
              track-by="id"
            />
          </b-field>
          <hr>
          <button class="button is-fullwidth" @click="save">СОХРАНИТЬ</button>
          <button class="button is-fullwidth" @click="resetForm">ОТМЕНИТЬ</button>
        </div>
        <ul v-else class="list">
          <li v-for="pack in packages" class="box" @click="editPack(pack.id)">
            <strong>{{ pack.title }}</strong> - <strong>{{ pack.sourceId }}</strong>
            <button class="delete is-pulled-right" @click.stop="del(pack.id)"></button>
            <p>{{ pack.description }}</p>
            <ul>
              <router-link v-for="item in pack.items" :to="{ name: 'SoftwareItem', params: { id: item.id } }" tag="li" class="box" :key="item.id">
                <strong>{{ item.title }}</strong>
              </router-link>
            </ul>
          </li>
        </ul>
      </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Packages',
  data () {
    return {
      showForm: false,
      pack: {
        sourceId: 0,
        title: '',
        apps: []
      }
    }
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapState({
      packages: state => state.software.packages,
      apps: state => state.software.apps.map(app => {
        return {
          id: app.id, title: app.title
        }
      })
    })
  },
  created () {
    this.getSoftware()
  },
  methods: {
    ...mapActions(['getSoftware', 'saveSoftwarePackage', 'deleteSoftwarePackage']),
    editPack (id) {
      this.pack = {
        ...this.packages.find(pack => pack.id === id)
      }
      this.showForm = true
    },
    resetForm () {
      this.pack = {
        sourceId: 0,
        title: ''
      }
      this.showForm = false
    },
    save () {
      if (this.pack.title && this.pack.sourceId) {
        this.saveSoftwarePackage(this.pack)
      }
      this.showForm = false
    },
    del (id) {
      this.$dialog.confirm({
        message: 'Действительно удалить?',
        onConfirm: () => {
          this.deleteSoftwarePackage(id)
          .then(() => this.$toast.open({
            message: 'Набор ПО удалён'
          }))
        }
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>



// WEBPACK FOOTER //
// Package.vue?10fa3b0c